import * as moment from "moment";

export class DatePickerConfig {
   public singleDate: boolean;
   public includeTime: boolean;
   public label: string;
   public ranges: any;
   public autoApply: boolean;
   public closeOnAutoApply: boolean;
   public opens: string;
   public showRanges: boolean;

   constructor() {
    this.singleDate = false;
    this.includeTime = true;
    this.label = null;
    this.ranges = null;
    this.autoApply = false;
    this.closeOnAutoApply = true;
    this.opens = 'right';
    this.showRanges = true;

    this.ranges = {
        'All Time': [
          moment().subtract(15, 'years'),
          moment().endOf('month')
        ],
        Today: [
          moment().startOf('day'),
          moment().endOf('day')
        ],
        Yesterday: [
          moment().subtract(1, 'days').startOf('day'),
          moment().subtract(1, 'days').endOf('day')
        ],
        'Last 7 Days': [
          moment().subtract(6, 'days').startOf('day'),
          moment().endOf('day')
        ],
        'Last 30 Days': [
          moment().subtract(29, 'days').startOf('day'),
          moment().endOf('day')
        ],
        'Last Week': [
          moment().subtract(1, 'week').startOf('isoWeek'),
          moment().subtract(1, 'week').endOf('isoWeek')
        ],
        // Retail week (Nielsen / IRI style): the most recent full Sunday–Saturday
        'Last Week (Sun–Sat)': [
          moment().subtract(1, 'week').startOf('week'),
          moment().subtract(1, 'week').endOf('week')
        ],
        'Last Month': [
          moment()
            .subtract(1, 'month')
            .startOf('month'),
          moment()
            .subtract(1, 'month')
            .endOf('month')
        ],
        'This Month': [
          moment().startOf('month'),
          moment().endOf('month')
        ]
      };
   }
}
export class DateRange {
    startDate: moment.Moment;
    endDate: moment.Moment;

    constructor( start: moment.Moment, end: moment.Moment ) {
        this.startDate = start;
        this.endDate = end;
    }
}
export class DateRangeSettings {
    dateConfig: DatePickerConfig;
    dateRange: DateRange;

    constructor() {
        this.dateRange = new DateRange( null, null );
        this.dateConfig = new DatePickerConfig();
    }
}
